import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { S3Image } from "src/core/shared/components/S3";

import { ISupport } from "../api/support.api";

const SupportCard: React.ReactFCWithChildren<{ supportDocument: ISupport; logo?: string; onSelect: (documnet: ISupport) => void }> = ({
  supportDocument,
  logo,
  onSelect
}) => (
  <SupportCardWrapper
    direction="vertical"
    onClick={() => onSelect(supportDocument)}
  >
    <Grid.Box className="image-wrapper">
      <S3Image
        level="public"
        alt="Placeholder video image"
        s3Key={logo}
      />

      {supportDocument.type === "VIDEO" && (
        <div className="play-wrapper">
          <Icon
            icon={Icons.PLAY}
            $fillColor="white"
          />
        </div>
      )}

      {supportDocument.type === "PDF" && (
        <div className="play-wrapper">
          <Icon
            icon={Icons.OPENNEW}
            $fillColor="white"
          />
        </div>
      )}
    </Grid.Box>

    <Grid.Box className="card-details">
      <div className="title-wrapper">
        <Text
          fontSize="h4"
          weight="bold"
          className="support-title"
        >
          {supportDocument.title}
        </Text>
      </div>
    </Grid.Box>
  </SupportCardWrapper>
);

const SupportCardWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    cursor: pointer;
    width: 300px;
    margin-right: ${theme.spacing.padding.md};
    margin-top: ${theme.spacing.padding.md};
    transition: ${theme.transition.quickest};

    &:hover {
      opacity: 0.7;

      .play-wrapper {
        opacity: 1;
      }
    }

    .card-details {
      border-top: solid 2px ${theme.colors.lightGrey};
      padding: ${theme.spacing.padding.md};
    }

    .image-wrapper {
      position: relative;
      padding: 3rem;
    }

    .play-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: ${theme.colors.midGrey};
      opacity: 0.8;
      border-radius: 50%;
      padding: 20px;
      transition: ${theme.transition.quickest};
    }
  `}
`;

export default SupportCard;
